import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

const initialState = fromJS({
  form: {
    travelInterruption: 'false',
    reasonsForTripInterruption: [],
    expenseTypesClaiming: [],
    pregnancyAdoptionClaimLegalAdoption: false,
    healthClaimSelfOrCompanion: false,
    healthClaimFamilyMember: false,
    healthClaimBusinessPartnerEtc: false,
    healthClaimHostAtDestination: false,
    travelCostsTransport: false,
    travelCostsNonRefundPrepaidAirfare: false,
    travelCostsChangeFees: false,
    travelCostsAirfareReturnPoint: false,
    travelCostsSeatUpgrade: false,
    travelCostsTransportCatchUp: false,
    travelCostsNonRefundTravelOther: false,
    travelCostsSingleSupplement: false,
    travelCostsOutOfPocket: false,
    expensesRelatedToDeath: false,
    travelCostsReturnOfRemains: false,
    travelCostsBurialCremation: false,
    travelCostsTransportFamilyMember: false,
    travelCostsNonRefundPrepaidAirfareFamilyMember: false,
    travelCostsChangeFeesFamilyMember: false,
    travelCostsAirfareReturnPointFamilyMember: false,
    travelCostsSeatUpgradeFamilyMember: false,
    travelCostsTransportCatchUpFamilyMember: false,
    travelCostsNonRefundTravelOtherFamilyMember: false,
    travelCostsSingleSupplementFamilyMember: false,
    travelCostsOutOfPocketFamilyMember: false,
    tripInterruptionFamilyMemberNonRefundPrepaidAirfareItems: [],
    tripInterruptionFamilyMemberChangeFeesItems: [],
    tripInterruptionFamilyMemberAirfareReturnPointItems: [],
    tripInterruptionFamilyMemberSeatUpgradeItems: [],
    tripInterruptionFamilyMemberTransportCatchUpItems: [],
    tripInterruptionFamilyMemberNonRefundTravelOtherItems: [],
    tripInterruptionFamilyMemberSingleSupplementItems: [],
    tripInterruptionFamilyMemberOutOfPocketItems: [],
    travelCostsTransportBusinessPartnerEtc: false,
    travelCostsNonRefundPrepaidAirfareBusinessPartnerEtc: false,
    travelCostsChangeFeesBusinessPartnerEtc: false,
    travelCostsAirfareReturnPointBusinessPartnerEtc: false,
    travelCostsSeatUpgradeBusinessPartnerEtc: false,
    travelCostsTransportCatchUpBusinessPartnerEtc: false,
    travelCostsNonRefundTravelOtherBusinessPartnerEtc: false,
    travelCostsSingleSupplementBusinessPartnerEtc: false,
    travelCostsOutOfPocketBusinessPartnerEtc: false,
    tripInterruptionBusinessPartnerEtcNonRefundPrepaidAirfareItems: [],
    tripInterruptionBusinessPartnerEtcChangeFeesItems: [],
    tripInterruptionBusinessPartnerEtcAirfareReturnPointItems: [],
    tripInterruptionBusinessPartnerEtcSeatUpgradeItems: [],
    tripInterruptionBusinessPartnerEtcTransportCatchUpItems: [],
    tripInterruptionBusinessPartnerEtcNonRefundTravelOtherItems: [],
    tripInterruptionBusinessPartnerEtcSingleSupplementItems: [],
    tripInterruptionBusinessPartnerEtcOutOfPocketItems: [],
    travelCostsTransportHostAtDestination: false,
    travelCostsNonRefundPrepaidAirfareHostAtDestination: false,
    travelCostsChangeFeesHostAtDestination: false,
    travelCostsAirfareReturnPointHostAtDestination: false,
    travelCostsSeatUpgradeHostAtDestination: false,
    travelCostsTransportCatchUpHostAtDestination: false,
    travelCostsNonRefundTravelOtherHostAtDestination: false,
    travelCostsSingleSupplementHostAtDestination: false,
    travelCostsOutOfPocketHostAtDestination: false,
    tripInterruptionHostAtDestinationNonRefundPrepaidAirfareItems: [],
    tripInterruptionHostAtDestinationChangeFeesItems: [],
    tripInterruptionHostAtDestinationAirfareReturnPointItems: [],
    tripInterruptionHostAtDestinationSeatUpgradeItems: [],
    tripInterruptionHostAtDestinationTransportCatchUpItems: [],
    tripInterruptionHostAtDestinationNonRefundTravelOtherItems: [],
    tripInterruptionHostAtDestinationSingleSupplementItems: [],
    tripInterruptionHostAtDestinationOutOfPocketItems: [],
    tripInterruptionNonRefundPrepaidAirfareItems: [],
    tripInterruptionChangeFeesItems: [],
    tripInterruptionAirfareReturnPointItems: [],
    tripInterruptionSeatUpgradeItems: [],
    tripInterruptionTransportCatchUpItems: [],
    tripInterruptionNonRefundTravelOtherItems: [],
    tripInterruptionSingleSupplementItems: [],
    tripInterruptionOutOfPocketItems: [],
    tripInterruptionReturnOfRemainsItems: [],
    tripInterruptionBurialCremationItems: [],
    travelCostsTransportPregnancyAdoption: false,
    travelCostsNonRefundPrepaidAirfarePregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesPregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionChangeFeesItems: [],
    travelCostsAirfareReturnPointPregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionAirfareReturnPointItems: [],
    travelCostsSeatUpgradePregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionSeatUpgradeItems: [],
    travelCostsTransportCatchUpPregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherPregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementPregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionSingleSupplementItems: [],
    travelCostsOutOfPocketPregnancyAdoption: false,
    tripInterruptionPregnancyAdoptionOutOfPocketItems: [],
    employmentEducationClaimJobTransfer: false,
    employmentEducationClaimInvoluntaryLossEmployment: false,
    employmentEducationClaimBusinessMeetingCancellation: false,
    employmentEducationClaimConferenceCancellation: false,
    travelCostsTransportEmploymentJobTransfer: false,
    travelCostsNonRefundPrepaidAirfareEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferChangeFeesItems: [],
    travelCostsAirfareReturnPointEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferAirfareReturnPointItems: [],
    travelCostsSeatUpgradeEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferSeatUpgradeItems: [],
    travelCostsTransportCatchUpEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferSingleSupplementItems: [],
    travelCostsOutOfPocketEmploymentJobTransfer: false,
    tripInterruptionEmploymentJobTransferOutOfPocketItems: [],
    travelCostsTransportEmploymentInvoluntaryLoss: false,
    travelCostsNonRefundPrepaidAirfareEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossChangeFeesItems: [],
    travelCostsAirfareReturnPointEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossAirfareReturnPointItems: [],
    travelCostsSeatUpgradeEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossSeatUpgradeItems: [],
    travelCostsTransportCatchUpEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossSingleSupplementItems: [],
    travelCostsOutOfPocketEmploymentInvoluntaryLoss: false,
    tripInterruptionEmploymentInvoluntaryLossOutOfPocketItems: [],
    travelCostsTransportEmploymentBusinessMeeting: false,
    travelCostsNonRefundPrepaidAirfareEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingChangeFeesItems: [],
    travelCostsAirfareReturnPointEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingAirfareReturnPointItems: [],
    travelCostsSeatUpgradeEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingSeatUpgradeItems: [],
    travelCostsTransportCatchUpEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingSingleSupplementItems: [],
    travelCostsOutOfPocketEmploymentBusinessMeeting: false,
    tripInterruptionEmploymentBusinessMeetingOutOfPocketItems: [],
    travelCostsTransportEmploymentConference: false,
    travelCostsNonRefundPrepaidAirfareEmploymentConference: false,
    tripInterruptionEmploymentConferenceNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesEmploymentConference: false,
    tripInterruptionEmploymentConferenceChangeFeesItems: [],
    travelCostsAirfareReturnPointEmploymentConference: false,
    tripInterruptionEmploymentConferenceAirfareReturnPointItems: [],
    travelCostsSeatUpgradeEmploymentConference: false,
    tripInterruptionEmploymentConferenceSeatUpgradeItems: [],
    travelCostsTransportCatchUpEmploymentConference: false,
    tripInterruptionEmploymentConferenceTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherEmploymentConference: false,
    tripInterruptionEmploymentConferenceNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementEmploymentConference: false,
    tripInterruptionEmploymentConferenceSingleSupplementItems: [],
    travelCostsOutOfPocketEmploymentConference: false,
    tripInterruptionEmploymentConferenceOutOfPocketItems: [],
    legalIssuesClaimJuryDuty: false,
    legalIssuesClaimMilitaryService: false,
    legalIssuesClaimTravelAdvisory: false,
    travelCostsTransportLegalIssuesJuryDuty: false,
    travelCostsNonRefundPrepaidAirfareLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutyNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutyChangeFeesItems: [],
    travelCostsAirfareReturnPointLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutyAirfareReturnPointItems: [],
    travelCostsSeatUpgradeLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutySeatUpgradeItems: [],
    travelCostsTransportCatchUpLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutyTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutyNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutySingleSupplementItems: [],
    travelCostsOutOfPocketLegalIssuesJuryDuty: false,
    tripInterruptionLegalIssuesJuryDutyOutOfPocketItems: [],
    travelCostsTransportLegalIssuesMilitaryService: false,
    travelCostsNonRefundPrepaidAirfareLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceChangeFeesItems: [],
    travelCostsAirfareReturnPointLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceAirfareReturnPointItems: [],
    travelCostsSeatUpgradeLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceSeatUpgradeItems: [],
    travelCostsTransportCatchUpLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceSingleSupplementItems: [],
    travelCostsOutOfPocketLegalIssuesMilitaryService: false,
    tripInterruptionLegalIssuesMilitaryServiceOutOfPocketItems: [],
    travelCostsTransportLegalIssuesTravelAdvisory: false,
    travelCostsNonRefundPrepaidAirfareLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisoryNonRefundPrepaidAirfareItems: [],
    travelCostsChangeFeesLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisoryChangeFeesItems: [],
    travelCostsAirfareReturnPointLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisoryAirfareReturnPointItems: [],
    travelCostsSeatUpgradeLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisorySeatUpgradeItems: [],
    travelCostsTransportCatchUpLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisoryTransportCatchUpItems: [],
    travelCostsNonRefundTravelOtherLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisoryNonRefundTravelOtherItems: [],
    travelCostsSingleSupplementLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisorySingleSupplementItems: [],
    travelCostsOutOfPocketLegalIssuesTravelAdvisory: false,
    tripInterruptionLegalIssuesTravelAdvisoryOutOfPocketItems: [],
    companyNameTravelInterruption: '',
    addressTravelInterruption: '',
    cityTravelInterruption: '',
    stateTravelInterruption: '',
    zipCodeTravelInterruption: '',
    contactTravelInterruption: '',
    phoneNumberTravelInterruption: '',
    includedInPackage: '',
    dateTripInterrupted: '',
    reasonForInterruption: '',
    nameOfPersonHavingSickness: '',
    dateOfBirth: '',
    relationshipToClaimant: '',
    dateSicknessOrInjuryBegan: '',
    dateEnded: '',
    natureOfSicknessOrInjury: '',
    periodOfHospitalization: '',
    lossInformationItems: [],
    fromDate: '',
    toDate: '',
    dateOfInitialPaymentDeposit: '',
    insureds: [],
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  let newState = state;
  fields.forEach((field) => {
    const defaultValue = initialState.getIn(['form', field]);
    newState = newState.setIn(['form', field], defaultValue);
  });
  return newState;
}

function tripInterruptionTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_STATE:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default tripInterruptionTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripInterruption/reducer.js